import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { addESimProfile } from '../api/esimProfilesActionsApi';

type UseESimProfileAddProps = {
  iccid: string;
  eid: string;
  mutationOption?: Omit<UseMutationOptions, 'mutationFn'>;
};

export const useESimProfileAdd = ({ iccid, eid, mutationOption = {} }: UseESimProfileAddProps) => {
  const { mutate } = useMutation({
    ...mutationOption,
    mutationFn: () => {
      return addESimProfile({ iccid, eid });
    },
  });

  return {
    addESimProfile: mutate,
  };
};
